import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { SUPPORTED_LANGS } from '../../i18n';

const LABELS = { kk: 'Қазақша', ru: 'Русский' };

export default function LanguageSwitcher({ compact = false }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'kk').split('-')[0];

  const onChange = (e) => {
    const next = e.target.value;
    i18n.changeLanguage(next);
  };

  return (
    <label className="inline-flex items-center gap-2 text-sm text-slate-600 dark:text-slate-300">
      {!compact && <Globe size={16} aria-hidden="true" />}
      <span className="sr-only">{t('common.language')}</span>
      <select
        value={current}
        onChange={onChange}
        className="rounded-md bg-slate-100 dark:bg-slate-800 border border-transparent focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 px-2 py-1 text-sm outline-none"
        aria-label={t('common.language')}
      >
        {SUPPORTED_LANGS.map((code) => (
          <option key={code} value={code}>
            {LABELS[code] || code}
          </option>
        ))}
      </select>
    </label>
  );
}
